import { useState } from "react";
import { addFileSlot, deleteFileSlot, deletedSlot, disabledSlot, downloadFileSlot, getAll, getFilesSlotById, getSlotById, newSlot, updateSlot } from "../services/slots.service";

const INITIAL_SUCCESS_ERROR = {
  getAll: "",
  addFileSlot: "",
  downloadFile: "",
};

export const useSlots = ({ spinner }) => {
  const [slotsList, setSlotsList] = useState([]);
  const [slot, setSlot] = useState({});
  const [slotFiles, setSlotFiles] = useState([]);
  const [success, setSuccess] = useState(INITIAL_SUCCESS_ERROR);
  const [error, setError] = useState(INITIAL_SUCCESS_ERROR);
  const [fileUploadResponse, setFileUploadResponse] = useState({});

  const getSlots = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await getAll(params);
    if (response.error) {
      spinner(false);
      setSlotsList([]);
      setError({ getAll: response.error });
    } else {
      spinner(false);
      setSlotsList(response.data);
    }
  };

  const getSlot = async (id, slotCommitteeId) => {
    clearAlerts();
    const response = await getSlotById(id, slotCommitteeId);
    if (response.error) {
      setSlot({});
      setError({ getSlotById: response.error });
    } else {
      setSlot(response.data);
    }
  };

  const clearAlerts = () => {
    setSuccess(INITIAL_SUCCESS_ERROR);
    setError(INITIAL_SUCCESS_ERROR);
  };

  const sanitizeForTable = (list, ignore = []) => {
    return list.map((item) => {
      const dataTable = {
        id: item.id,
        name: item.slots,
      };
      if (ignore.length > 0) {
        ignore.map((key) => {
          if (Object.keys(dataTable).includes(key)) delete dataTable[key];
        });
      }
      return dataTable;
    });
  };

  const create = async (request) => {
    clearAlerts();
    spinner(true);
    const response = await newSlot(request);
    spinner(false);
    if (response.error) {
      setError({ create: response.error });
    } else {
      setSuccess({ create: "create" });
    }
  };

  const update = async (id, request) => {
    clearAlerts();
    spinner(true);
    const response = await updateSlot(id, request);
    spinner(false);
    if (response.error) {
      setError({ update: response.error });
    } else {
      setSuccess({ update: "update" });
    }
  };


  const addFile = async (request, id, type) => {
    clearAlerts();
    spinner(true);
    const response = await addFileSlot(request, id, type);
    spinner(false);
    if (response.error) {
      setFileUploadResponse({});
      setError({ addFileSlot: response.error });
    } else {
      setFileUploadResponse(response);
      setSuccess({ addFileSlot: "addFileSlot" });
    }
  };

  const getFilesSlot = async (id) => {
    clearAlerts();
    const response = await getFilesSlotById(id);
    if (response.error) {
      setSlotFiles([]);
      setError({ getFilesSlot: response.error });
    } else {
      setSlotFiles(response.data);
    }
  };


  const deleteFile = async (id) => {
    clearAlerts();
    spinner(true);
    const response = await deleteFileSlot(id);
    spinner(false);
    if (response.error) {
      setFileUploadResponse({});
      setError({ deleteFileSlot: response.error });
    } else {
      setFileUploadResponse(response);
      setSuccess({ deleteFileSlot: "deleteFileSlot" });
    }

    return response;
  };

  const downloadFile = async (id, fileName) => {
    clearAlerts();
    spinner(true);
    const response = await downloadFileSlot(id);

    spinner(false);
    if (response.error) {
      setFileUploadResponse({});
      setError({ downloadFile: response.error });
    } else {
      const url = window.URL.createObjectURL(new Blob([response.data.data],));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      
      document.body.appendChild(link);
  
      link.click();
      setFileUploadResponse(response);
      setSuccess({ downloadFile: "downloadFile" });
    }
  };

  const setDisabled = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await disabledSlot(params);
    spinner(false);
    if (response.error) {
      setSlotsList([]);
      setError({ disabledSlot: response.error });
    } else {
      setSuccess({ disabled: "disabled" });
      setSlotsList(response.data);
    }
  };

  const setDeleted = async (params) => {
    clearAlerts();
    spinner(true);
    const response = await deletedSlot(params);
    spinner(false);
    if (response.error) {
      setSlotsList([]);
      setError({ deletedSlot: response.error });
    } else {
      setSuccess({ deleted: "deleted" });
      setSlotsList(response.data);
    }
  };

  return {
    getSlots,
    getSlot,
    slotFiles,
    addFile,
    sanitizeForTable,
    create,
    setDisabled,
    update,
    addFile,
    setDeleted,
    deleteFile,
    downloadFile,
    getFilesSlot,
    slotsList,
    fileUploadResponse,
    slot,
    success,
    error,
  };
};
